import { render, staticRenderFns } from "./CaseEdit.vue?vue&type=template&id=08fa7797&scoped=true"
import script from "./CaseEdit.vue?vue&type=script&lang=js"
export * from "./CaseEdit.vue?vue&type=script&lang=js"
import style0 from "./CaseEdit.vue?vue&type=style&index=0&id=08fa7797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa7797",
  null
  
)

export default component.exports